export const validateAddress = (address) => {
    const addressFormat = /.\s./;
    return Object.assign(Object.assign({}, (!addressFormat.test(address) && { address: ['Incorrect address format'] })), (!address && { address: ['Required'] }));
};
//# sourceMappingURL=validate-address.js.map